<template>
   <div>
      <div>
    <div class="d-flex">
    </div>
  </div>
      <section class="cms-content">
        <h2 class="cms-content__header">{{category_page.category_name}}</h2>
        <p class="cms-content__data"   @click="handleContentClick($event)" v-html="cms_page.html"></p>
      </section>
        <div class="child-pages grey" v-if="child_pages.length || categories.length" >
          <div class="tile-list__icon">
            <img v-if="category_page._attachments" class="tile-list__icon-image " :src="'data:' + category_page._attachments.image.content_type + ';base64,' + category_page._attachments.image.data" alt="" />
          </div>
          <p  v-if="hubbdata.catagories.section !== undefined">{{hubbdata.catagories.section}}</p>

          <ul class="child-pages__list">
            <div v-if="child_pages.length">
              <router-link
                  :to="{ name: 'cms_page', params: { id: child_page.id }}"
                  class=" child-pages__link"
                  v-for="child_page in child_pages"
                  :key="child_page.id"
              >
                <li class="accent child-pages__list-item" >

                  <span class="black--text"><strong>{{ child_page.page_title }}</strong></span>
                  <v-icon class="v-list-item__chevron" large color="black">mdi-chevron-right</v-icon>


                </li>

              </router-link>
            </div>
            <div v-if="categories.length">
              <router-link
                  :to="{ name: 'category', params: { id: category.id }}"
                  class=" child-pages__link"
                  v-for="category in categories"
                  :key="category.id"
              >

                <li class="accent child-pages__list-item" >

                  <span class="black--text"><strong>{{ category.category_name }}</strong></span>
                  <v-icon class="v-list-item__chevron" large color="black">mdi-chevron-right</v-icon>


                </li>
              </router-link>
            </div>
          </ul>
      </div>

      <template>
        <v-expansion-panels role="region">
          <v-expansion-panel @click="scrollToTop()" ripple v-if="organisations.length">
            <v-expansion-panel-header class="green">
             <template v-slot:actions>
              <v-icon color="white">mdi-chevron-down</v-icon>
            </template>
            {{hubbdata.catagories.organisations}}
            </v-expansion-panel-header>
              <v-expansion-panel-content>
                <OrganisationList role="list" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          <v-expansion-panel @click="scrollToTop()" v-if="documents.length" ripple>
            <v-expansion-panel-header class="green">{{hubbdata.catagories.documents}}
              <template v-slot:actions>
                <v-icon color="white">mdi-chevron-down</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
            <DocumentsList />
            </v-expansion-panel-content>
          </v-expansion-panel >
          <v-expansion-panel @click="scrollToTop()" v-if="links.length" ripple>
          <v-expansion-panel-header class="green">{{hubbdata.catagories.links}}
           <template v-slot:actions>
              <v-icon color="white">mdi-chevron-down</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <LinksList />
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
      </template>


    </div>
</template>

<style lang="scss" scoped>
  .v-list-item__chevron {
    right: 20px;
  }
  .expansion-panel{
    margin-bottom: 20px;
  }
  .cms-content {
    text-align: center;
    padding: 20px 20px 10px 20px;
    &__header {
      font-size:40px;
      padding-bottom: 20px;
    }
    &__data {
      font-size: 16px;
      text-align: center;

    }
  }


  .v-expansion-panel-header i {
     color: white;
      font-size: 40px;
  }

  .v-icon {
     color: white;
      font-size: 40px;
  }
  .v-expansion-panel-header {
    text-align: center;
    padding: 30px;
    color: white;
    margin-bottom: 1px;
    font-size: 22px;
    border-radius: 0px;
    font-weight: 700;
    i {
      color: white;
      font-size: 40px;
    }
  }

  .child-pages {

    &__list {
      padding: 0px 20px 20px 20px;
      width: 100%
    }

    &__list-item {
      list-style: none;
      padding: 20px 20px 20px 20px;
      text-align:center;
      margin-bottom: 20px;




    }

    &__link {
      text-decoration: none;
      font-size: 22px;
    }
  }

  .tile-list__icon {
    background-color: #00aeef;
    margin: -40px 0px 10px 0px;

  }
  .child-pages {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 40px;

  }

  .v-expansion-panel-content {
    margin-top: 25px;
  }
  .v-expansion-panel-header__icon {
    color: white;
    font-size: 40px;
  }
  .v-icon {

  }




</style>

<script>
  import hubbdata from "@/hubbdata";
  import OrganisationList from "@/components/Organisations/OrganisationList";
  import LinksList from "@/components/Links/LinksList";
  import DocumentsList from "@/components/Documents/DocumentsList";
  import smoothscroll from 'smoothscroll-polyfill';



  export default {
    data: () => ({
      panel: [0, 1],
      readonly: false,
    }),
    components: {
        OrganisationList,
        LinksList,
        DocumentsList
    },

    computed: {
        // A getter for the cms page with this cat
        category_page() {
            return hubbdata.getters.getCategoryPageById(this.$route.params.id)
        },
        cms_page() {
            return hubbdata.getters.getCmsPageByCategory(this.$route.params.id)
        },
        categories() {
          return hubbdata.getters.getCategoriesPageByCategory(this.$route.params.id)
        },
        child_pages() {
            return hubbdata.getters.getCmsPagesByParentId(this.cms_page.id)
        },
        organisations() {
            return hubbdata.getters.getOrganisationsByCategory(this.$route.params.id)
        },
        links() {
            return hubbdata.getters.getLinksByCategory(this.$route.params.id)
        },
        documents() {
            return hubbdata.getters.getDocumentsByCategory(this.$route.params.id)
        },
        hubbdata() {
          return hubbdata.getters.translations;
        },
    },
    methods: {
      scrollToTop() {
        smoothscroll.polyfill();
        let extraHeight = 0
        let child_pages
        if (localStorage.getItem('show_alert') === null) {
          extraHeight = 68
        }

         if (document.getElementsByClassName("child-pages").length !== 0) {
            child_pages = document.getElementsByClassName("child-pages")[0].offsetHeight
         }
         else {
            child_pages = 0
         }
        setTimeout(() => {
          window.scrollTo({
            top: document.getElementsByClassName("cms-content")[0].offsetHeight + child_pages + extraHeight,
            behavior: 'smooth'

          })
        }, 300);



      },
      //handleContentClick is in global sharedMethods mixin
    },
    mounted: function() {
      ga('set', 'title', this.category_page.category_name);// eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
    }
  }
</script>
